import clsx from "clsx";

export default function Impresa({ impresa }) {
  return (
    <section
      aria-labelledby="applicant-information-title"
      className={clsx(impresa.sub ? "col-span-2 sm:col-span-2" : "col-span-2")}
    >
      <div className="bg-white shadow sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h2
            id="applicant-information-title"
            className="text-lg font-medium leading-6 text-gray-900"
          >
            {impresa.sub
              ? "Informazioni Impresa Subappaltatrie"
              : "Informazioni Impresa Esecutrice"}
          </h2>
        </div>
        <div className="border-t border-gray-200 px-4 py-5 sm:px-6">
          <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">Nome</dt>
              <dd className="mt-1 flex gap-x-2 text-sm text-gray-900">
                {impresa.logo && (
                  <img src={impresa.logo} className="my-auto h-6 w-6" />
                )}
                <span className="my-auto">{impresa.nome}</span>
              </dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">Telefono</dt>
              <dd className="mt-1 text-sm text-gray-900">{impresa.telefono}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">Sede Legale</dt>
              <dd className="mt-1 text-sm text-gray-900">{impresa.legale}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">
                Sede Operativa
              </dt>
              <dd className="mt-1 text-sm text-gray-900">
                {impresa.operativa}
              </dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">Mail</dt>
              <dd className="mt-1 text-sm text-gray-900">{impresa.mail}</dd>
            </div>
            <div className="sm:col-span-1">
              <dt className="text-sm font-medium text-gray-500">Pec</dt>
              <dd className="mt-1 text-sm text-gray-900">{impresa.pec}</dd>
            </div>
            {impresa.opere && (
              <div className="sm:col-span-2">
                <dt className="text-sm font-medium text-gray-500">Opere</dt>
                <dd className="mt-1 text-sm text-gray-900">{impresa.opere}</dd>
              </div>
            )}
          </dl>
        </div>
      </div>
    </section>
  );
}
